import * as React from "react";
import { gql, useMutation, MutationHookOptions, MutationTuple } from "@apollo/client";
import {
  OtpValidateAdminMutationMutation,
  OtpValidateAdminMutationMutationVariables
} from "../../../../schemaTypes";

export const otpValidateAdminMutation = gql`
  mutation OtpValidateAdminMutation(
    $verificationCode: String!
    $email: String!
  ) {
    otpValidateAdmin(
      verificationCode: $verificationCode
      email: $email
    ){
      errors{
        path
        message
      }
      message
    }
  }
`;

export interface WithOtpValidateAdmin {
  otpValidateAdmin: MutationTuple<OtpValidateAdminMutationMutation, OtpValidateAdminMutationMutationVariables>[0];
}

interface Props {
  children: (data: WithOtpValidateAdmin) => React.ReactElement | null;
  options?: MutationHookOptions<OtpValidateAdminMutationMutation, OtpValidateAdminMutationMutationVariables>;
}

export const OtpValidateAdmin: React.FC<Props> = ({ children, options }) => {
  const [otpValidateAdmin] = useMutation<OtpValidateAdminMutationMutation, OtpValidateAdminMutationMutationVariables>(
    otpValidateAdminMutation,
    options
  );

  return children({ otpValidateAdmin });
};